import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

export default class Feedback extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedback: this.props.values,
      fromReviewTeam: this.props.values.from_review_team,
    }
    this.dismissFeedback = this.dismissFeedback.bind(this)
    this.onFeedbackUpdated = this.props.onFeedbackUpdated
  }

  dismissFeedback() {
    let warning = window.confirm(
      "Are you sure you want to delete this comment? This cannot be undone."
    )

    if (warning) {
      const request = $.ajax({
        type: "DELETE",
        url: `/services/${this.props.service.slug}/feedbacks/${this.props.index}`,
        data: JSON.stringify({
          feedback_path: this.props.pathObjs,
          authenticity_token: window.App.authenticityToken,
        }),
        dataType: "json",
        contentType: "application/json",
      })

      request.done(
        function (response) {
          this.onFeedbackUpdated(response)
        }.bind(this)
      )
    }
  }

  render() {
    const classNames = "feedback-item"
    const username = this.state.fromReviewTeam
      ? `Review Team (${this.state.feedback.username})`
      : this.state.feedback.username
    return (
      <div className={classNames} data-click-behaviour="keep-open">
        {!this.props.preview ? (
          <span
            className="dismiss"
            data-click-behaviour="keep-open"
            onClick={this.dismissFeedback}
          />
        ) : null}
        <div className="feedback-text" data-click-behaviour="keep-open">
          {this.state.feedback.feedback}
        </div>
        <div className="name" data-click-behaviour="keep-open">
          {username}
        </div>
        <div className="timestamp" data-click-behaviour="keep-open">
          {moment(new Date(this.state.feedback.time).toISOString()).format(
            "MMMM Do YYYY, h:mm:ss a"
          )}
        </div>
      </div>
    )
  }
}

Feedback.propTypes = {
  service: PropTypes.object,
  values: PropTypes.object,
  pathObjs: PropTypes.array,
  preview: PropTypes.bool,
  index: PropTypes.number,
  onFeedbackUpdated: PropTypes.func,
}
